import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex);

const cookiesTimeoutDays = 365;


export default {
  namespaced: true,

  state: () => {
    let darkMode = Cookies.get('darkMode');  // 'true', 'false', undefined
    darkMode = darkMode ? darkMode === 'true' : true;

    return {
      sidebarShow: 'responsive',
      sidebarMinimize: true,  // minimized sidebar by default when development mode is enabled
      darkMode: darkMode,
    };
  },

  getters: {
    darkMode(state) {
      return state.darkMode;
    },

    themeClass(state) {
      return state.darkMode ? 'c-dark-theme' : '';
    },
  },

  mutations: {
    toggleSidebarDesktop(state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow);
      state.sidebarShow = sidebarOpened ? false : 'responsive';
    },

    toggleSidebarMobile(state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow);
      state.sidebarShow = sidebarClosed ? true : 'responsive';
    },

    setDarkMode(state, value) {
      state.darkMode = value;
      Cookies.set('darkMode', value, {expires: cookiesTimeoutDays});
    },

    set(state, [variable, value]) {
      state[variable] = value;
    },

    toggle(state, variable) {
      state[variable] = !state[variable];
    },
  },

  actions: {
    // ...
  },
}
